import { DEFAULT_WHEEL_SECTIONS } from '../data/defaultWheelSections';
import type { WheelSection } from '../types/goals';
import { prefixedId } from './idUtils';

const DEFAULT_SECTION_IDS = new Set(DEFAULT_WHEEL_SECTIONS.map((section) => section.id));

export function normalizeWheelSectionsForPersistence(sections: WheelSection[]): WheelSection[] {
  return sections.map((section) => (
    DEFAULT_SECTION_IDS.has(section.id)
      ? { ...section, id: prefixedId('sec') }
      : section
  ));
}